import { useLoading } from "src/hooks/useLoading";
import { useEffect, useRef } from 'react';
import LoadingBar, { LoadingBarRef } from "react-top-loading-bar";

const LoadingProgressBar = () => {
   const { loading } = useLoading();
   const ref = useRef<LoadingBarRef>(null);

   useEffect(() => {
      if (loading) {
         ref.current?.continuousStart();
      } else {
         ref.current?.complete()
      }

   }, [loading]);

   return (
      <LoadingBar ref={ref} shadow={false} color="#FACA15" height={4} />
   );
}

export default LoadingProgressBar;
